/** * * Asynchronously loads the component for
How to Switch
* */ import { lazyLoad } from "utils/loadable";
export const HowToSwitch = lazyLoad(
  () => import("./index"),
  (module) => module.HowToSwitch
);
